import React from 'react'
import styled from 'styled-components'
import { InvestTitleText } from 'src/components/Global/Text/TitleText'
import { InvestModalButton } from 'src/components/Global/Button/Button'
import { TomatoImageIcon } from 'src/assets'
import { Link, useLocation } from 'react-router-dom'
const InvestWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: 500;
  padding-top: 23px;
  .weight {
    font-weight: 500;
    margin-top: 12px;
  }
  p {
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 27px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    height: 128px;
    overflow-y: scroll;
    & {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .imgIcon {
    width: 100%;
    height: 267px;
    padding-top: 3px;
  }
`
const InvestInfo = () => {
  let location = useLocation()
  return (
    <InvestWrapper>
      <InvestTitleText>Investment details</InvestTitleText>
      <img src={TomatoImageIcon} alt="" className="imgIcon" />
      <InvestTitleText className="weight">Tomato Farm</InvestTitleText>
      <p>
        F&K Savings is flagging off a new investment portfolio to help our
        users/potential users achieve financial freedom and meet their money
        goals. Our alternative investment options as always allows our users to
        put their loose funds in profitable ventures. This new portfolio is
        called the F&K SAVINGS TOMATO-FIX. Tomato farming is the cultivation of
        tomato for the production of tomato fruits. The cultivation of tomato
        can be profitable if done in the right way.
      </p>
      <Link to={`/amount-to-invest`} state={{ backgroundLocation: location }}>
        <InvestModalButton>Invest</InvestModalButton>
      </Link>
    </InvestWrapper>
  )
}
export { InvestInfo }
